export const TOTAL_COLORANT_AMOUNT_BELLOW_MIN_AMOUNT = 1;
export const TOTAL_COLORANT_AMOUNT_OVER_MAX_AMOUNT = 2;
export const COLORANT_AMOUNT_BELLOW_MIN_DOSABLE_AMOUNT = 3;
export const OVERFILL_DETECTED = 4;
export const COLORANT_BATCH_STATUS_WARNING = 5;
export const COLORANT_BATCH_STATUS_INVALID = 6;
export const COLORANT_BASE_RULES_BROKEN = 7;
